<template>
  <router-link :to="to" class="sidenav-item" :class="{ active }">
    <span class="sidenav-icon">
      <!-- 고객 아이콘 -->
      <svg
        v-if="icon === 'customers'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
      <!-- 대시보드 아이콘 -->
      <svg
        v-else-if="icon === 'dashboard'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
      </svg>
      <!-- 상품 아이콘 -->
      <svg
        v-else-if="icon === 'products'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
        ></path>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
      <!-- 구독 아이콘 -->
      <svg
        v-else-if="icon === 'subscription'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
      <!-- 결제 아이콘 -->
      <svg
        v-else-if="icon === 'payment'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
        <line x1="1" y1="10" x2="23" y2="10"></line>
      </svg>
      <!-- 채널 연동 아이콘 -->
      <svg
        v-else-if="icon === 'channels'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
        ></path>
        <path
          d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
        ></path>
      </svg>
      <!-- 프로모션 아이콘 (tag/percent) -->
      <svg
        v-else-if="icon === 'promotion'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
        ></path>
        <line x1="7" y1="7" x2="7.01" y2="7"></line>
      </svg>
      <!-- 암호 아이콘 -->
      <svg
        v-else-if="icon === 'password'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="7.5" cy="15.5" r="5.5"></circle>
        <path d="M12 12l8-8"></path>
        <path d="M17 4h3v3"></path>
        <path d="M15 6l3 3"></path>
      </svg>
      <!-- 보안 아이콘 -->
      <svg
        v-else-if="icon === 'security'"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 640 640"
        fill="currentColor"
      >
        <path
          d="M240 160L240 224L400 224L400 160C400 115.8 364.2 80 320 80C275.8 80 240 115.8 240 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224zM400 272L240 272L240 272L192 272L192 272C183.2 272 176 279.2 176 288L176 512C176 520.8 183.2 528 192 528L448 528C456.8 528 464 520.8 464 512L464 288C464 279.2 456.8 272 448 272L448 272L400 272L400 272zM280 300C291 300 300 309 300 320L300 340L340 340L340 320C340 309 349 300 360 300C371 300 380 309 380 320L380 340L400 340C411 340 420 349 420 360C420 371 411 380 400 380L380 380L380 420L400 420C411 420 420 429 420 440C420 451 411 460 400 460L380 460L380 480C380 491 371 500 360 500C349 500 340 491 340 480L340 460L300 460L300 480C300 491 291 500 280 500C269 500 260 491 260 480L260 460L240 460C229 460 220 451 220 440C220 429 229 420 240 420L260 420L260 380L240 380C229 380 220 371 220 360C220 349 229 340 240 340L260 340L260 320C260 309 269 300 280 300zM300 380L300 420L340 420L340 380L300 380z"
        />
      </svg>
    </span>
    <span class="sidenav-text">{{ text }}</span>
  </router-link>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'SidenavItem',
  props: {
    to: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped>
.sidenav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.2s;
  position: relative;
}

.sidenav-item:hover {
  color: white;
  background: rgba(255, 255, 255, 0.05);
}

.sidenav-item.active {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

.sidenav-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0 3px 3px 0;
}

.sidenav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.sidenav-text {
  font-size: 14px;
  font-weight: 500;
}
</style>
